// Actions
export var SHOW_LOADING = "SHOW_LOADING"; // Statut initial

export var INITIAL_STATE = {
  loading: {
    showLoading: false
  }
};